module.exports = __webpack_public_path__ + "static/img/step_01.4398413.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/step_01.jpg
// module id = FpSv
// module chunks = 59